import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const consummasterAdapter = createEntityAdapter({})

const initialState = consummasterAdapter.getInitialState()

export const consummasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getconsummaster: builder.query({
            query: () => ({
                url: '/consummaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedconsummaster = responseData.map(consummaster => {
                    // console.log(brandmaster)
                    consummaster.id = consummaster._id
                    // console.log(brandmaster)
                    return consummaster
                });
                return consummasterAdapter.setAll(initialState, loadedconsummaster)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'CONSUMMASTER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'CONSUMMASTER', id }))
                    ]
                } else return [{ type: 'CONSUMMASTER', id: 'LIST' }]
            }
        }),
        addNewconsummaster: builder.mutation({
            query: initialUserData => ({
                url: '/consummaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'CONSUMMASTER', id: "LIST" }
            ]
        }),        
        updateconsummaster: builder.mutation({
            query: initialUserData => ({
                url: '/consummaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMMASTER', id: arg.id }
            ]
        }),        
        deleteconsummaster: builder.mutation({
            query: ({ id }) => ({
                url: `/consummaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMMASTER', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetconsummasterQuery,
    useAddNewconsummasterMutation,
    useUpdateconsummasterMutation,
    useDeleteconsummasterMutation
} = consummasterApiSlice

// returns the query result object
export const selectconsummasterResult = consummasterApiSlice.endpoints.getconsummaster.select()

// creates memoized selector
const selectconsummasterData = createSelector(
    selectconsummasterResult,
    consummasterResult => consummasterResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllconsummaster,
    selectById: selectconsummasterById,
    selectIds: selectconsummasterIds
    // Pass in a selector that returns the users slice of state
} = consummasterAdapter.getSelectors(state => selectconsummasterData(state) ?? initialState)